import api from './api';
import { AuthResponse } from '../types';

export const authService = {
  async register(data: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    companyName: string;
    companyType?: string;
    role?: string;
  }): Promise<AuthResponse> {
    const response = await api.post('/auth/register', data);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('lastActivity', Date.now().toString());
    }
    return response.data;
  },

  async login(identifier: string, password: string): Promise<AuthResponse> {
    const response = await api.post('/auth/login', { identifier, password });
    if (response.data.token) {
      this.storeAuth(response.data);
    }
    return response.data;
  },

  async verifyTwoFactorLogin(twoFactorTempToken: string, code: string): Promise<AuthResponse> {
    const response = await api.post('/auth/verify-2fa-login', { twoFactorTempToken, code });
    if (response.data.token) {
      this.storeAuth(response.data);
    }
    return response.data;
  },

  async activateAccount(token: string, password: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/auth/activate-account', { token, password });
    return response.data;
  },

  async refreshToken(): Promise<AuthResponse> {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      throw new Error('Refresh token not found');
    }
    
    const response = await api.post('/auth/refresh-token', { refreshToken });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('lastActivity', Date.now().toString());
    }
    return response.data;
  },

  async getMe() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  updateStoredUser(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
  },

  storeAuth(data: AuthResponse) {
    if (!data.token || !data.refreshToken || !data.user) {
      return;
    }

    localStorage.setItem('token', data.token);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('lastActivity', Date.now().toString());
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.put('/auth/change-password', { currentPassword, newPassword });
  },

  async logout() {
    try {
      // Pozovi backend da invalidira refresh token
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Error during logout:', error);
    } finally {
      // Očisti local storage u svakom slučaju
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      localStorage.removeItem('lastActivity');
      window.location.href = '/login';
    }
  },

  updateActivity() {
    localStorage.setItem('lastActivity', Date.now().toString());
  },

  getLastActivity(): number {
    const lastActivity = localStorage.getItem('lastActivity');
    return lastActivity ? parseInt(lastActivity) : 0;
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('token');
  }
}; 